import { render, staticRenderFns } from "./HelpCenterHome.vue?vue&type=template&id=3ff874d5&scoped=true"
import script from "./HelpCenterHome.vue?vue&type=script&lang=js"
export * from "./HelpCenterHome.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterHome.vue?vue&type=style&index=0&id=3ff874d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff874d5",
  null
  
)

export default component.exports